import { createI18n } from "vue-i18n";
import constant from "../const";
// import jaMessages from "./locales/ja";
// import enMessages from "./locales/en";
import consoleController from "@/utils/logUtil";

// 初期化時にはデフォルトロケールだけを静的にロードする
const i18n = createI18n({
  locale: constant.DEFAULT_LOCALE,
  fallbackLocale: constant.DEFAULT_LOCALE,
  messages: {}, // 初期状態では空にしておく
});

/**
 * 読み込み済み言語のキャッシュ
 */
const loadedLanguage = new Set();

/**
 * 外部から呼び出すロケール切り替え/ロード関数
 * @param {string} locale - ロードするロケールコード (例: 'en', 'zh-TW')
 */
export async function loadLocaleMessages(locale) {
  // 既にロードされている場合は何もしない
  if (loadedLanguage.has(locale)) {
    consoleController("log", `already loaded: ${locale}`);
    return Promise.resolve();
  }

  try {
    consoleController("log", `load locale message: ${locale}`);
    // Webpack/Vite の動的 import() を利用して非同期ロード
    const messages = await import(`@/i18n/locales/${locale}.js`);

    // ロードしたメッセージを i18n インスタンスに追加
    i18n.global.setLocaleMessage(locale, messages.default);

    // 読み込み済みをマーク
    loadedLanguage.add(locale);

    // // 現在のロケールを切り替える
    // i18n.global.locale.value = locale;

    return messages.default;
  } catch (error) {
    // フォールバック
    if (locale !== constant.DEFAULT_LOCALE) {
      consoleController("error", error);
      consoleController(
        "log",
        `fallback to default locale: ${constant.DEFAULT_LOCALE}`
      );
      return loadLocaleMessages(constant.DEFAULT_LOCALE);
    }

    throw error;
  }
}

export default i18n;
